export interface IReport {
  title: string;
  description: string;
  uri: string;
  order: number;
  params: IReportParam[];
}

export enum IReportParamType {
  string = "string",
  integer = "integer",
  personId = "personId",
  associationId = "associationId",
  date = "date",
  datetime = "datetime",
}

export interface IReportParam {
  name: string;
  id: string;
  description: string;
  optional: boolean;
  type: IReportParamType;
  default?: any;
}
